const phoneFilter = (value?: string | number | null): string | undefined => {
  if (value === null || value === undefined) { return undefined };

  const phoneNumber = `${value}`.replace(/[- ()]/g, '');
  const phoneNumberArray = [...phoneNumber];
  
  if (!phoneNumberArray.length) { return undefined }
  const thirdChunk = phoneNumberArray.splice(-4).join('');
  const secondChunk = phoneNumberArray.splice(-3).join('');
  const firstChunk = phoneNumberArray.splice(-3).join('');
  const rest = phoneNumberArray.join('');
  
  return `${rest} (${firstChunk}) ${secondChunk}-${thirdChunk}`;
}

export { phoneFilter };
export default phoneFilter;
